function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 0a5.23 5.23 0 0 1 3.711 1.538 5.192 5.192 0 0 1 1.544 3.698 5.16 5.16 0 0 1-1.544 3.698 6.84 6.84 0 0 1-.55.476c.881.238 1.69.714 2.314 1.336A5.156 5.156 0 0 1 14 14.389v.989a.618.618 0 0 1-.625.622H.625A.618.618 0 0 1 0 15.378v-.971c0-1.428.588-2.71 1.525-3.643A5.246 5.246 0 0 1 3.84 9.428a4.674 4.674 0 0 1-.551-.476 5.192 5.192 0 0 1-1.544-3.698c0-1.446.588-2.746 1.544-3.698A5.14 5.14 0 0 1 7 0zm2.848 2.398A4.021 4.021 0 0 0 7 1.227c-1.102 0-2.113.439-2.848 1.171a3.96 3.96 0 0 0-1.176 2.838 4.07 4.07 0 0 0 1.176 2.837A4.033 4.033 0 0 0 7 9.245a4.1 4.1 0 0 0 2.848-1.172 3.96 3.96 0 0 0 1.176-2.837c0-1.117-.46-2.106-1.176-2.838zm-1.03 8.073H5.182c-1.084 0-2.076.44-2.793 1.154a3.924 3.924 0 0 0-1.157 2.782v.366h11.52v-.366c0-1.08-.441-2.068-1.158-2.782A3.877 3.877 0 0 0 8.82 10.47z"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "#919DA9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.ea542204.svg";
export { ForwardRef as ReactComponent };